import * as React from "react";
import { cn } from "@/lib/utils";

export interface ListboxProps extends React.HTMLAttributes<HTMLUListElement> {
  selectedKeys?: string[];
  onSelectionChange?: (keys: string[]) => void;
}

const Listbox = React.forwardRef<HTMLUListElement, ListboxProps>(
  ({ className, children, selectedKeys, onSelectionChange, ...props }, ref) => {
    // selectedKeys and onSelectionChange are handled by the adapter layer
    // We don't pass them to the DOM element
    return (
      <ul
        ref={ref}
        className={cn(
          "max-h-full rounded-xl border p-1 text-popover-foreground",
          className
        )}
        {...props}
      >
        {children}
      </ul>
    );
  }
);
Listbox.displayName = "Listbox";

export interface ListboxItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  key?: string;
}

const ListboxItem = React.forwardRef<HTMLLIElement, ListboxItemProps>(
  ({ className, ...props }, ref) => {
    return (
      <li
        ref={ref}
        className={cn(
          "relative flex w-full cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled=true]:pointer-not-allowed data-[disabled=true]:opacity-70 data-[selected=true]:bg-accent",
          className
        )}
        {...props}
      />
    );
  }
);
ListboxItem.displayName = "ListboxItem";

export { Listbox, ListboxItem };
